<div class="body-large-bold text-inverse-color px-spacing-sm">
  {{ currentPageData()?.name }}
</div>
